
































































import {Component, Vue, Prop} from "vue-property-decorator";
import ReportTizhi from "./components/report-tizhi.vue";
import ReportJifenjiahe from "./components/report-jifenjiahe.vue";
import ReportTongue from "./components/report-tongue.vue";
import ReportTongue80 from "./components/report-tongue80.vue";
import ReportShedi from "./components/report-shedi.vue";
import ReportFace from "./components/report-face.vue";
import ReportFace15 from "./components/report-face15.vue";
import ReportPulse from "./components/report-pulse.vue";
import ReportHand from "./components/report-hand.vue";
import ReportWen from "./components/report-wen.vue";
import ReportZhengxing from "./components/report-zhengxing.vue";
import ReportFengmian from "./components/report-fengmian.vue";
import Reportqianming from "./components/report-qianming.vue";
import ReportMulu from "./components/report-mulu.vue";
import ReportJiBen from "./components/report-jiben.vue";

import ReportWenZhen from "./components/report-wenzhen.vue";
import ReportPulse6 from "./components/report-pulse6.vue";
import ReportTizhiAi from "./components/report-tizhi-ai.vue";
import ReportAiBianzheng from "./components/report-AI-bianzheng.vue";
import ReportAiTzcp from "./components/report-AI-tzcp.vue";
import ReportZhuanbing from "@/components/template-transfer-pc/report/components/report-zhuanbing.vue";

@Component({
  components: {
    ReportZhuanbing,
    ReportTizhi,
    ReportJifenjiahe,
    ReportTongue,
    ReportTongue80,
    ReportShedi,
    ReportFace,
    ReportFace15,
    ReportPulse,
    ReportHand,
    ReportWen,
    ReportZhengxing,
    ReportFengmian,
    Reportqianming,
    ReportMulu,
    ReportJiBen,
    ReportWenZhen,
    ReportPulse6,
    ReportTizhiAi,
    ReportAiBianzheng,
    ReportAiTzcp,
  },
})
export default class Name extends Vue {
  @Prop()
  private detail: any; // 报告为多个时，传入的detail为数组
  @Prop()
  private data: any;
  @Prop()
  private ifEdit: any;
  @Prop()
  private ifShowFengmian: any;
  @Prop()
  private ifShowMulu: any;
  @Prop()
  private ifShowQianMing: any;
  @Prop()
  private ifShowJiBen: any;

  @Prop()
  private time: any;

  private changeData(params: any) {
    this.$emit("changeData", params);
  }
}
